import { useEffect, useRef } from 'react';
import { useFormsContext } from '../context';
export const useRegisterError = (error) => {
    const { createRef, registerError, deregisterError } = useFormsContext();
    const { current: [refKey, refValue], } = useRef(createRef());
    useEffect(() => {
        return () => {
            deregisterError(refKey);
        };
    }, []);
    useEffect(() => {
        if (error) {
            registerError(refKey, refValue);
        }
        if (!error) {
            deregisterError(refKey);
        }
    }, [error]);
    return { refKey, refValue };
};
//# sourceMappingURL=useRegisterError.js.map